import { infoFetchGetTituloI, makeTitulo } from "dtos/titulo";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { ENDPOINTS } from "./endpoints";
import { servicesUtils } from "./utils/services.utils";
import { infoFetchGetAreaI, makeArea } from "dtos/area";

export const getArea = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFetchGetAreaI>
  >({
    method: "GET",
    uri: ENDPOINTS.AREA,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeArea(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postArea = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetAreaI>({
    method: "POST",
    uri: ENDPOINTS.AREA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeArea(response);
};

export const putArea = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFetchGetAreaI>({
    method: "PUT",
    uri: ENDPOINTS.AREA,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeArea(response);
};

export const deleteArea = async (id: any) => {
  const response = await sendRequest<infoFetchGetAreaI>({
    method: "DELETE",
    uri: ENDPOINTS.AREA + "/" + id,
  });
  return makeArea(response);
};
